/**
 * Notifications API client (Wave F).
 */
import { api } from '@/lib/api';

export const notificationsApi = {
  list({ unread = false, limit = 50, offset = 0 } = {}) {
    const qs = new URLSearchParams();
    if (unread) qs.set('unread', 'true');
    qs.set('limit', String(limit));
    qs.set('offset', String(offset));
    return api.get(`/notifications?${qs.toString()}`);
  },
  unreadCount() { return api.get('/notifications/unread-count'); },
  create(payload) { return api.post('/notifications', payload); },
  markRead(id) { return api.post(`/notifications/${id}/read`, {}); },
  markAllRead() { return api.post('/notifications/read-all', {}); },
  remove(id) { return api.delete(`/notifications/${id}`); },
  clearAll() { return api.delete('/notifications'); },
};

export default notificationsApi;
